export const SUBMIT_BUTTON_OFFSET = 48;

export const ROUTING_LAYOUT_ANIMATION_DURATION = 350;
